enum SearchType {
  CLUBS = "clubs",
  PLAYERS = "players",
}

export default SearchType;
